import React from "react";

export default function WhatsIncluded({ items }) {
  return (
    <section className="whats-included-section">
      <div className="container">
        <div className="mu-eyebrow" style={{ color: "var(--mu-purple-700)" }}>The Details</div>
        <h2 className="section-title mb-4">What's Included</h2>

        <div className="row g-3">
          {items.map((item, i) => (
            <div className="col-md-4" key={i}>
              <div className="included-card">
                <div className="service-card-icon"></div>
                <h6>{item.title}</h6>
                <p>{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
